import { useEffect, useState } from "react"

import type { MarketPeerCompany } from "@/db/queries/market"

import {
  type TopInstallersMarket,
  TopInstallersSection,
} from "./top-installers-section"

type GeoState = {
  title: string
  companies: MarketPeerCompany[]
  market: TopInstallersMarket
}

export function TopInstallersGeoSwap({
  companyLongSlug,
  fallbackTitle,
  fallbackCompanies,
  fallbackMarket,
}: {
  companyLongSlug: string
  fallbackTitle: string
  fallbackCompanies: MarketPeerCompany[]
  fallbackMarket: TopInstallersMarket
}) {
  const [state, setState] = useState<GeoState>({
    title: fallbackTitle,
    companies: fallbackCompanies,
    market: fallbackMarket,
  })

  useEffect(() => {
    const controller = new AbortController()

    fetch(`/api/company/${companyLongSlug}/market-peers`, {
      signal: controller.signal,
    })
      .then((res) => {
        if (res.ok) return res.json()
        throw new Error(`Failed to fetch market peers: ${res.status}`)
      })
      .then((data) => {
        if (data.companies?.length) {
          setState({
            title: `Top Solar Installers in ${data.marketName}`,
            companies: data.companies,
            market: {
              name: data.marketName,
              poolSize: data.poolSize,
              pageHref: data.marketPageHref,
            },
          })
        }
      })
      .catch((err) => {
        if (err.name !== "AbortError") {
          console.error("Failed to load market peers:", err)
        }
      })

    return () => controller.abort()
  }, [companyLongSlug])

  return (
    <TopInstallersSection
      title={state.title}
      companies={state.companies}
      market={state.market}
    />
  )
}
